<cb-dialog dialogHeading="Lot Details">
    <form class="flex-col flex" #lotDetailsForm="ngForm">
        @if (data.clientSale.isDesignAndBuild) {
            <cb-input
                type="number"
                label="Lot Number"
                name="lotNumber"
                [pattern]="positiveIntegerPattern"
                [(ngModel)]="clientSaleLotDetails.lotNumber"
            ></cb-input>
        }
        @if (data.clientSale.isHouseAndLand) {
            <cb-checkbox
                name="allow-nominee"
                label="Is Showhome"
                [(ngModel)]="clientSaleLotDetails.isShowHome"
            ></cb-checkbox>
        }
        <cb-checkbox
            label="Lot has Title"
            name="lotHasTitle"
            [(ngModel)]="clientSaleLotDetails.hasTitle"
        >
        </cb-checkbox>
        @if (!clientSaleLotDetails.hasTitle) {
            <cb-datepicker
                label="Actual / Expected Title Date"
                [required]="!clientSaleLotDetails.hasTitle"
                name="expectedTitleDate"
                [(ngModel)]="clientSaleLotDetails.expectedTitleDate"
                [pickerType]="'calendar'"
            >
            </cb-datepicker>
        }
        @if (
            clientSaleLotDetails &&
            buildTypes &&
            (data.clientSale.isDesignAndBuild || data.clientSale.isThirdPartyHouseAndLand)
        ) {
            <cb-select
                [required]="true"
                name="buildType"
                label="Build Type"
                [(ngModel)]="clientSaleLotDetails.buildTypeId"
                [options]="buildTypes"
            >
            </cb-select>
        }
        @if (data.clientSale.isDesignAndBuild || data.clientSale.isThirdPartyHouseAndLand) {
            <cb-select
                label="Road Direction"
                name="roadDIrection"
                [(ngModel)]="clientSaleLotDetails.roadDirectionId"
                [options]="COMPASS_DIRECTION_TYPE_ENUM"
            >
            </cb-select>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="lotDetailsForm.pristine || lotDetailsForm.invalid"
            (click)="save()"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
